import React, { useCallback, useEffect, useState } from "react";
import styles from "./hallContractForm.module.scss";
import { Box, Grid, Typography } from "@mui/material";
import {
  CustomRequiredInputLabel,
  CustomTextFeildforFamily,
} from "../common/StyledComponents/StyledFields";
import constants from "./../../config/constants.json";
import { apiRequest, catchErrorMessageHandler, getUserSelectedRole } from "../../infrastructure/backendService";
import { useNavigate, useSearchParams } from "react-router-dom";
import apiPath from "../../config/apiPaths.json";
import toast from "react-hot-toast";
import ErrorPopup from "../common/ErrorPopup";
import useSharedState from "./useSharedState";
interface FormFooterProps {
  sign: string;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  navigationButtons?: React.ReactNode;
}

const FormFooter = (props: FormFooterProps) => {
  const [searchParam] = useSearchParams();
  const hasManagerLevelRole = constants.showDashBoardForRoles.includes(getUserSelectedRole() || "");
  const status = searchParam.get("STATUS");
  const navigate = useNavigate();
  const intials=searchParam.get("devoteeInitials");
  const hallBookingId=searchParam.get("hallBookingId");
  const contractId=searchParam.get("contractId");
  const [initial,setInitial]=useState("")
  const sharedState = useSharedState(parseInt(hallBookingId ?? "0"),parseInt(contractId ?? "0"),status ?? "");
  // useEffect(() => {
  //   handleCallbackSign();
  // }, [initial]);
  
  // const handleCallbackSign = useCallback(() => {
  //   handleSign();
  // }, [initial]);

  // const handleSign=()=>{
  //   if(status) {
  //     apiRequest({
  //       method: "GET",
  //       endpoint: `${apiPath.contractFormHallBookingManagerFlow}/${hallBookingId}/contracts/${contractId}`,
  //       includeToken: true,
  //     })
  //       .then((res) => {
  //         console.log(res.data);
  //         setInitial(res.data.devoteeInitials)
          
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         // toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
  //         //   duration: constants.TOAST_POPUP_DURATION,
  //         // });
  //       });
  // }}
  
  return (
    <Box className={styles.footer}>
      <Box>
        <Grid xs={12} sm={3} item className={styles.signInComponent}>
          {CustomRequiredInputLabel("User’s Initial’s", false)}
          <CustomTextFeildforFamily
            sx={{ width: "200px" }}
            className={styles.textField}
            disabled={hasManagerLevelRole || status=="FORM_TO_BE_SIGNED" || status=="viewcontractform"}
            value={(hasManagerLevelRole || status == "FORM_TO_BE_SIGNED" || status=="viewcontractform") ? sharedState.devoteeInitials : props.sign}
            onChange={props.handleInputChange}
          />
          <Typography style={{ color: "red" }}>{props.error}</Typography>
        </Grid>
      </Box>
      <Box>
      <Box sx={{ display: "flex", gap: "1rem", float: "right", alignItems: "center", mb: "20px" }}>
          {props?.navigationButtons}
      </Box>
      </Box>
      <Box>
        <Typography className={styles.footerMessage}>
          {constants.HALL_FORM_FOOTER_TEXT}
        </Typography>
      </Box>
    </Box>
  );
};

export default FormFooter;
